'use strict';

/**
 * Helper functions for getting and setting url parameters.
 */

const urlParams = {

    /*
     * Get a url (or the current url from window) and return an object with all params as key: value.
     */
    get: (url) => {
        // get query string from url (optional) or window
        let queryString = url ? url.split('?')[1] : window.location.search.slice(1);

        // we'll store the parameters here
        let params = {};

        if (queryString) {

            // stuff after # is not part of query string, so get rid of it
            queryString = queryString.split('#')[0];

            // split our query string into its component parts
            let arr = queryString.split('&');

            for (var i = 0; i < arr.length; i++) {
                // separate the keys and the values
                let a = arr[i].split('=');

                // set parameter name and value (use 'true' if empty)
                let paramName = a[0];
                let paramValue = typeof (a[1]) === 'undefined' ? true : a[1];

                // (optional) keep case consistent
                paramName = paramName.toLowerCase();
                if (typeof paramValue === 'string') paramValue = paramValue.toLowerCase();

                // if the paramName ends with square brackets, e.g. colors[] or colors[2]
                if (paramName.match(/\[(\d+)?\]$/)) {

                    // create key if it doesn't exist
                    let key = paramName.replace(/\[(\d+)?\]/, '');
                    if (!params[key]) params[key] = [];

                    // if it's an indexed array e.g. colors[2]
                    if (paramName.match(/\[\d+\]$/)) {
                        // get the index value and add the entry at the appropriate position
                        let index = /\[(\d+)\]/.exec(paramName)[1];
                        params[key][index] = paramValue;
                    } else {
                        // otherwise add the value to the end of the array
                        params[key].push(paramValue);
                    }

                } else {
                    // we're dealing with a string
                    if (!params[paramName]) {
                        // if it doesn't exist, create property
                        params[paramName] = paramValue;
                    } else if (obj[paramName] && typeof params[paramName] === 'string'){
                        // if property does exist and it's a string, convert it to an array
                        params[paramName] = [params[paramName]];
                        params[paramName].push(paramValue);
                    } else {
                        // otherwise add the property
                        params[paramName].push(paramValue);
                    }
                }
            }
        }
        return params;
    },

    /*
     * Take an object of key: val pairs and set them as url params.
     */
    set: (params) => {

        // Keep document title
        let documentTitle = document.title;

        // Get the page url without params
        let urlSplit=( window.location.href ).split( "?" );

        //write the final url
        let urlParams = { Title: documentTitle, Url: urlSplit[0] + '?' + $.param( params ) };

        history.pushState(urlParams, urlParams.Title, urlParams.Url);

    }

};

export default urlParams;
